const respond = {
    1: "Success!",
    2: "Failed!",
    3: "Pending!",
    4: "Bad request!",
    5: "Unauthorized request!",
    6: "Internal server error!",
    7: "Forbidden access!",
    8: "Resource not found!",
    9: "Request timeout!",
    10: "Something went wrong!",
    11: "Service unavailable!",
    12: "Gateway timeout!",
    13: "Unsupported media type!",
    14: "Too many requests!",
    15: "Not implemented!",
    16: "Successfully deleted! The record has been removed.",

    21: "Required fields are missing!",
    22: (field) => `You've reached the end of ${field} list!`,
    23: (field) => `${field} does not exist!`,
    24: (field) => `${field} is invalid!`,
    25: (field) => `${field} already exists!`,
    26: (field) => `User - ${field} is not allowed to access this resource!`,
    27: (field) => `${field} not found!`,
    28: (field) => `${field} deleted!`,
    29: (field) => `${field} details updated!`,
    30: (field) => `Failed to update ${field} details!`,
    31: (field) => `Failed to add new ${field}!`,
    32: (field) => `${field} created successfully!`,
    
    51: "User logged-in",
    55: "Invalid password!",
    56: "User creation failed!",
    59: "Invalid Credentials!",
};

export const getResponseMessage = (sm, field) => {
    if (!sm || !respond[sm]) {
        return respond[10]; // Default error message
    }

    return typeof respond[sm] === 'function' 
        ? respond[sm](field) 
        : respond[sm];
};

export default respond;